// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PB_MENU_SUBSCRIBED_PHOTOBLOGS = "Odeb\u00edr\u00e1m ze zdi";
